// InvDiscardSheet.jsx — "Discard this count?" confirmation shared by Cycle Count and Stock Take.
import React from 'react';

const overlay = { position: 'absolute', inset: 0, background: 'rgba(0,0,0,.4)', zIndex: 600,
                  display: 'flex', alignItems: 'flex-end' };
const sheet   = { background: '#fff', borderRadius: '16px 16px 0 0', padding: '20px 16px 28px', width: '100%' };

export default function InvDiscardSheet({ title, detail, busy, onKeep, onDiscard }) {
    return (
        <div style={overlay} onClick={busy ? undefined : onKeep}>
            <div style={sheet} onClick={e => e.stopPropagation()}>
                <div style={{ fontSize: 17, fontWeight: 700, color: '#111827', marginBottom: 6 }}>{title}</div>
                <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 16 }}>{detail}</div>
                <div style={{ display: 'flex', gap: 10 }}>
                    <button type="button" disabled={busy} onClick={onKeep}
                            style={{ flex: 1, padding: '12px 14px', background: '#f3f4f6', border: '1px solid #e5e7eb',
                                     borderRadius: 8, fontSize: 14, fontWeight: 600, color: '#374151', cursor: 'pointer' }}>
                        Keep it
                    </button>
                    <button type="button" disabled={busy} onClick={onDiscard}
                            style={{ flex: 1, padding: '12px 14px', background: busy ? '#9ca3af' : '#b91c1c', border: 'none',
                                     borderRadius: 8, fontSize: 14, fontWeight: 700, color: '#fff',
                                     cursor: busy ? 'not-allowed' : 'pointer' }}>
                        {busy ? 'Discarding…' : 'Discard'}
                    </button>
                </div>
            </div>
        </div>
    );
}
